import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { sectorsData } from '../../data/sectors.data';
import { GetAllSectorsAction } from './sectors.actions';
import { ISectors } from '../../core/interfaces/sectors.interface';

export interface SectorsStateModel {
  sectors: ISectors[];
}

@State<SectorsStateModel>({
  name: 'sectors',
  defaults: {
    sectors: [],
  },
})
@Injectable()
export class SectorsState {
  @Selector() static GetAllData(state: SectorsStateModel): ISectors[] {
    return state?.sectors ? state?.sectors : [];
  }

  sectorsArray: ISectors[] = [...sectorsData];

  constructor() {}

  @Action(GetAllSectorsAction)
  GetAllSectorsAction(ctx: StateContext<SectorsStateModel>) {
    ctx.patchState({
      sectors: this.sectorsArray,
    });
  }
}
